export default __webpack_public_path__ + "static/media/M08.d8f51c09.svg";